import React, { useState, FC, useEffect } from "react";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MenuItem from "./MenuItem";

import { List, ListItemButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

// let $: JQueryStatic = (window as any)["jQuery"];

interface MultiLevelProps {
    item: {
        items: Array<any>;
        icon: string;
        title: string;
        to: string;
    };
    navigateToFirstChild: boolean;
    closeSideBar: () => any;
    customNavigationLink: string;
}

const MultiLevel: FC<MultiLevelProps> = ({ item,navigateToFirstChild,closeSideBar = () => {},customNavigationLink }) => {
    const { items: children } = item;
    const [open, setOpen] = useState<boolean>(false);

    const navigate = useNavigate();

    const handleClick = () => {
        setOpen((prev: boolean) => !prev);
    };

    useEffect(()=>{
        if(customNavigationLink !== undefined){
            navigate(customNavigationLink);
        }
        else if(open && navigateToFirstChild){
            navigate(children[0]?.to) // navigate to first list Item
            // closeSideBar();
        }
    },[open,navigateToFirstChild])

    return (
        <React.Fragment>
                <List component="div" disablePadding onClick={handleClick} className="sidebarPill" id={children[0]?.to}>
                    <ListItemButton sx={{ pl: 4 }} >
                        {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                        <ListItemText primary={item.title} />
                        {open ? <ExpandLess sx={{ color : open ? "#B21412" : "#707070"}}/> : <ExpandMore sx={{ color : open ? "#B21412" : "#707070"}}/>}
                    </ListItemButton>
                </List>

            <Collapse in={open} timeout="auto" className="multiLevel" unmountOnExit>
                <List component="div" disablePadding style={{ marginLeft: "46px" }}>
                    {children.map((child: any, key: number) => (
                        <MenuItem key={key} item={child} />
                    ))}
                </List>
            </Collapse>
        </React.Fragment>
    );
};

export default MultiLevel;